import axios from "./configs/axiosConfig";

export const getEquipmentTypes = async () => {
  const url = `/equipment/types`;
  return await axios.get(url);
};